import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { useEffect, useState } from "react";
import { sanitizeNetworkData } from "@/js/utils/helpers";
import { deleteCookie, getCookies } from "@/js/utils/cookie";

function useLogRocket(logRocketEnabled) {
  const [oneTrustAllowedGroups, setOneTrustAllowedGroups] = useState(["C0001"]);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (logRocketEnabled && oneTrustAllowedGroups.includes("C0002")) {
      if (initialized) return;
      setInitialized(true);
      LogRocket.init("vuvnvg/frontier", {
        release: process.env.release,
        network: {
          requestSanitizer: sanitizeNetworkData(["addressKey"]),
          responseSanitizer: sanitizeNetworkData(["addressKey"]),
        },
        dom: {
          privateClassNameBlocklist: ["fs-mask"],
        },
      });

      setupLogRocketReact(LogRocket);
      const sessionId = window?._Cohesion?.sessionId;
      LogRocket.identify(sessionId);
    } else {
      // Cookie cleanup, mostly to cover us in the scenario that
      // LogRocket is disabled as a result of a cookie consent change
      setInitialized(false);
      const cookies = getCookies();
      Object.keys(cookies).forEach((cookieName) => {
        if (cookieName.startsWith("_lr_")) {
          deleteCookie(cookieName);
        }
      });
    }
  }, [logRocketEnabled, oneTrustAllowedGroups, initialized]);

  useEffect(() => {
    cohesion("consent:ready", () => {
      setOneTrustAllowedGroups(cohesion?.consent("list"));
    });
    cohesion("consent:changed", (groups) => {
      setOneTrustAllowedGroups(groups);
    });
  }, []);
}

export default useLogRocket;
